import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { TransactionSearchDto } from './dto/transaction-search.dto';
import { TransactionDto } from './transaction.dto';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  constructor(private _apiService: ApiService) {}

  search(searchDto: TransactionSearchDto, ignoreCache?: boolean): Promise<PagedResultGeneric<TransactionDto>> {
    const cacheOptions = ignoreCache ? null : this._apiService.getDefaultApiCacheOptionsForNoCache();
    return this._apiService.getPaged('Transactions', searchDto, cacheOptions);
  }
}
